"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE = void 0;
var DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE = 'DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE';
exports.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE = DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE;